import React from "react";
import { useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { BG, CARD_BG, BORDER, AMBER } from "./colors";

// A rendering error anywhere unmounted the whole app and left an empty page that only a
// reload fixed (QE "blank page", N7). This shows what happened and the way out instead.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("Page crashed:", error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <Box sx={{ minHeight: "100vh", backgroundColor: BG, px: "24px", pt: "100px", textAlign: "center" }}>
        <Box sx={{ maxWidth: "420px", mx: "auto", backgroundColor: CARD_BG, border: `1px solid ${BORDER}`, borderRadius: "12px", p: "24px" }}>
          <Typography sx={{ fontSize: "1.3rem", fontWeight: 800, color: "#fff", mb: "8px" }}>Something went wrong</Typography>
          <Typography sx={{ fontSize: "0.9rem", color: "rgba(255,255,255,0.7)", lineHeight: 1.6, mb: "20px" }}>
            This page hit an error. Your saved work is safe. Reload to try again, or go back to Home.
          </Typography>
          <Box sx={{ display: "flex", gap: "10px", justifyContent: "center" }}>
            <Button
              variant="contained"
              onClick={() => window.location.reload()}
              sx={{ backgroundColor: AMBER, color: "#0d1117", fontWeight: 700, textTransform: "none", boxShadow: "none", "&:hover": { backgroundColor: "#e5a730", boxShadow: "none" } }}
            >
              Reload
            </Button>
            <Button
              onClick={() => window.location.assign("/")}
              sx={{ color: "rgba(255,255,255,0.75)", border: `1px solid ${BORDER}`, textTransform: "none", fontWeight: 600 }}
            >
              Home
            </Button>
          </Box>
        </Box>
      </Box>
    );
  }
}

// Reset on navigation, so moving to another page recovers without a reload.
export default function RouteErrorBoundary({ children }) {
  const { pathname } = useLocation();
  return <ErrorBoundary key={pathname}>{children}</ErrorBoundary>;
}
